import { Box, Button, Flex, Link, Text } from '@chakra-ui/react'
import { LANGUAGES } from 'commons/constants/language'
import {
	PaymentPageTermsUrls,
	PrivacyPolicyUrls,
	ReportMoneyPotUrls
} from 'commons/constants/supportUrls'
import { BgColors, TextColors } from 'commons/design-system/tokens'
import { Trans, useTranslation } from 'react-i18next'

type Props = {
	firstname: string | undefined
}

const footerTcsLinkProps = {
	color: 'inherit',
	fontWeight: 'inherit',
	fontSize: 'inherit',
	fontFamily: 'inherit',
	textDecoration: 'underline',
	textUnderlineOffset: '0.1em',
	_hover: {
		color: 'inherit',
		textDecoration: 'underline',
		textUnderlineOffset: '0.1em'
	}
}

export const FooterMoneyPot = ({ firstname }: Props) => {
	const { t, i18n } = useTranslation()

	const lydiaUrl = i18n.language === 'fr' ? 'https://www.lydia.me/' : 'https://www.lydia.me/en/'
	const termsUrl =
		i18n.language === LANGUAGES.FRENCH
			? PaymentPageTermsUrls[LANGUAGES.FRENCH]
			: PaymentPageTermsUrls[LANGUAGES.ENGLISH]
	const privacyUrl =
		i18n.language === LANGUAGES.FRENCH
			? PrivacyPolicyUrls[LANGUAGES.FRENCH]
			: PrivacyPolicyUrls[LANGUAGES.ENGLISH]
	const reportUrl =
		i18n.language === LANGUAGES.FRENCH
			? ReportMoneyPotUrls[LANGUAGES.FRENCH]
			: ReportMoneyPotUrls[LANGUAGES.ENGLISH]

	return (
		<Flex mt='70px' flexDirection='column' alignItems='center'>
			<Box
				maxW='600px'
				p={{ base: '30px 20px', md: '60px 105px' }}
				border='4px solid rgba(255, 255, 255, 0.75)'
				bg='rgba(255, 255, 255, 0.75)'
				backdropFilter='blur(9px)'
				borderRadius='16px'
			>
				<Text
					fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
					fontWeight={700}
					color={TextColors.SECONDARY}
					fontSize='16px'
					lineHeight={'normal'}
					textAlign='center'
				>
					<Trans
						i18nKey='money_pot.footer_text'
						values={{ firstname: firstname }}
						components={{
							lydiaLink: (
								<Link
									fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
									fontWeight={700}
									href={lydiaUrl}
									target='_blank'
									rel='noopener noreferrer'
									color={TextColors.SECONDARY}
									textDecoration='underline'
								/>
							)
						}}
					/>
				</Text>
				<Button
					fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
					fontWeight={700}
					onClick={() => window.open(`${process.env.REACT_APP_LYDIA_ME_APP_URL}pots?s=t`, '_blank')}
					display='block'
					m={'30px auto 0'}
					color='#0180ff'
					bg='#E9F5FD'
					fontSize='16px'
					borderRadius='56px'
					textAlign='center'
				>
					{t('money_pot.footer_btn')}
				</Button>
			</Box>
			<Text
				fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
				fontWeight={500}
				mt={8}
				fontSize='15px'
				color={TextColors.PRIMARY}
				textAlign='center'
				maxW='500px'
				lineHeight={'normal'}
			>
				<Trans
					i18nKey='money_pot.footer_tcs'
					components={{
						termsLink: (
							<Link
								href={termsUrl}
								target='_blank'
								rel='noopener noreferrer'
								{...footerTcsLinkProps}
							/>
						),
						privacyLink: (
							<Link
								href={privacyUrl}
								target='_blank'
								rel='noopener noreferrer'
								{...footerTcsLinkProps}
							/>
						)
					}}
				/>
			</Text>
			<Link
				href={reportUrl}
				target='_blank'
				rel='noopener noreferrer'
				mt={8}
				px={6}
				py={3}
				borderRadius='full'
				bg={BgColors.NEUTRAL_DARK}
				color={TextColors.OPPOSITE_PRIMARY}
				fontFamily="'Montserrat', 'Helvetica Neue', Helvetica, Arial, sans-serif"
				fontWeight={700}
				fontSize='16px'
				textAlign='center'
				_hover={{ bg: BgColors.NEUTRAL_DARK_HOVER, textDecoration: 'none' }}
			>
				{t('money_pot.report_page')}
			</Link>
		</Flex>
	)
}
